import React from 'react';
import moment from 'moment';

import { WorkOrderContext } from './context';

import AccountService from '../../Services/api/AccountService';
import UnitsService from '../../Services/api/Units';
import Utils from '../../Services/Utils';
import WorkOrderCVService from '../../Services/api/WorkOrderCVService';
import WorkOrderTriggerService from '../../Services/api/WorkOrderTriggerService';
import DynamicFormDataService from "../../Services/api/DynamicFormData";
import CustomConfigService from '../../Services/api/CustomConfig';

class WorkOrderContextProvider extends React.Component {
  state = {
    errors: {},
    property: null,
    customValuesOptions: {},
    customValuesParents: {},
    platformFields: {
      fields: [],
    },
    unitOptions: [],
    accountsOptions: [],
    workOrderData: {},
    customConfigsForValidation: []
  }

  onChangeWorkOrderError = (field, errorMessage, workOrderData) => {
    const { errors } = this.state;
    const { groupId } = workOrderData;
    let change = false;
    let newError = false;
    const { id, time } = workOrderData;

    if (!errors[groupId]) {
      errors[groupId] = [{ id:id, time:time, errors: {}}];
      newError = true;
    }
    let errorIndex = -1;
    errors[groupId].map((item, index) => {
      let sameId = id && id === item.id;
      let sameTimeStamp = moment(item.time).isSame(time);
      if (sameId || sameTimeStamp) {
        errorIndex = index;
      }
    });
    if (errorIndex < 0) {
      errors[groupId].push({ id:id, time:time, errors: {}});
      errorIndex = errors[groupId].length-1;
      errors[groupId][errorIndex].errors[field] = errorMessage;
      change = !Utils.isNull(errorMessage);
    }
    else if (errors[groupId][errorIndex].errors[field] !== errorMessage) {
      errors[groupId][errorIndex].errors[field] = errorMessage;
      change = !newError || !Utils.isNull(errorMessage);
    }
    if (change) {
      this.setState({ errors: errors });
    }
  }

  onSetCustomValuesParents = (parents) => {
    this.setState({
      customValuesParents: parents
    });
  }

  onLoadSelectUnit = async (propertyParam, filters) => {
    const { id } = propertyParam
    const propertyId = id || propertyParam; 
    const params = {
      ...filters,
      property: propertyId,
      essential: true,
      disable_pagination: true,
      with_building: true,
      // fetch_resident: true
    };
    const unitOptionsRes = await UnitsService.list(params);

    if (unitOptionsRes) {
      const parseUnitOptions = unitOptionsRes.map((item) => {
        return {
          value: item.id,
          label: item.number,
          resident_email: item.resident_email,
          resident_name: item.resident_name,
          resident_phone: item.resident_phone,
          resident_external_id: item.resident_external_id
        }
      });
      this.setState({
        unitOptions: parseUnitOptions,
        property: propertyId,
      })
    }
  }

  onLoadSelectAccounts = async (propertyParam, filters) => {
    const { accountsOptions, property } = this.state;
    const { id } = propertyParam;
    const propertyId = id || propertyParam;
    const sameProperty = property === propertyId;

    if (accountsOptions.length > 0 && sameProperty) {
      return;
    }

    const params = {
      ...filters,
      property: propertyId,
      essential: true,
      disable_pagination: true,
      user_is_active: true
    };
    const accountsOptionsRes = await AccountService.list(params);

    if (accountsOptionsRes) {
      const parseAccountOptions = accountsOptionsRes.map((item) => {
        const { user, id } = item;
        return {
          value: id,
          label: `${user.first_name} ${user.last_name}`
        }
      });
      this.setState({
        accountsOptions: parseAccountOptions,
        property: propertyId,
      });
    }
  }

  onLoadSelectCustomValues = async (propertyParam, field, parents, filters) => {
    const { customValuesOptions, property, customValuesParents } = this.state;
    const { id } = propertyParam;
    const propertyId = id || propertyParam;
    const sameProperty = property === propertyId;
    const parentsId = customValuesParents[field.name] ? (customValuesParents[field.name].parents || []) : [];
    const newParents = parents || [];
    const sameParents = newParents.every(p => parentsId.includes(p));

    if (!Utils.isNull(customValuesOptions[field.name]) && sameProperty && sameParents) {
      return;
    }

    const params = {
      ...filters,
      property: propertyId,
      essential: true,
      disable_pagination: true,
      type: field.type,
      parents: newParents.join(',')
    };
    const customValuesOptionsRes = await WorkOrderCVService.list(params);

    if (customValuesOptionsRes) {
      customValuesOptions[field.name] = customValuesOptionsRes.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      this.setState({
        customValuesOptions: customValuesOptions,
        property: propertyId,
      });
    }
  }

  onLoadPlatformFields = async (propertyParam, filters, account) => {
    const { property } = this.state;
    const { id } = propertyParam;
    const propertyId = id || propertyParam;
    const sameProperty = property === propertyId;

    if (sameProperty) {
      return;
    }
    const params = {
      ...filters,
      property: propertyId,
      disable_pagination: true,
    };

    const platformFieldsOptionsRes = await WorkOrderTriggerService.getPlatformFields(params);

    if (platformFieldsOptionsRes && platformFieldsOptionsRes.fields) {
      this.setState({
        platformFields: platformFieldsOptionsRes,
        property: propertyId,
      });
      platformFieldsOptionsRes.fields.map((field) => {
        if (field.field_type === 'custom_value') {
          this.onLoadSelectCustomValues(propertyParam, field, null, filters);
        }
      });

      if(platformFieldsOptionsRes.pms_platform == 'yardi'){
        this.getCustomConfigs(account)
      }

    }
  }

  onSubmitCreateTriggerWorkOrder = async (data, dynamicFormDataId) => {
    const params = {
      field_group_id: data.groupId,
      trigger_id: data.triggerId,
      dynamic_form_data_id: dynamicFormDataId,
      trigger_type: 2,
    }
    const serializeData = await data.serialize(data);
    let result = null;
    if (serializeData.id) {
      params.work_order_id = serializeData.id;
      result = await DynamicFormDataService.updateTrigger(serializeData, params );
    }
    else {
      result = await DynamicFormDataService.createTrigger(serializeData, params );
    }
    return result;
  }

  getCustomConfigs = async (accountId) => {
    try {
      const configs = await CustomConfigService.getByAccount(accountId);
      if(configs.results && configs.results.length > 0){
        this.setState({
          customConfigsForValidation: configs.results,
        });
      }
      
    } catch (error) {
    }
  }
  

  render () {
    const {
      errors,
      unitOptions,
      customValuesOptions,
      customValuesParents,
      platformFields,
      accountsOptions,
      property,
      customConfigsForValidation
    } = this.state;

    return (
      <WorkOrderContext.Provider value={{
        errors,
        unitOptions,
        customValuesOptions,
        customValuesParents,
        platformFields,
        accountsOptions,
        property,
        customConfigsForValidation,
        onChangeWorkOrderError: this.onChangeWorkOrderError,
        onSetCustomValuesParents: this.onSetCustomValuesParents,
        onLoadSelectUnit: this.onLoadSelectUnit,
        onLoadSelectCustomValues: this.onLoadSelectCustomValues,
        onLoadPlatformFields: this.onLoadPlatformFields,
        onLoadSelectAccounts: this.onLoadSelectAccounts,
        onSubmitCreateTriggerWorkOrder: this.onSubmitCreateTriggerWorkOrder,
      }}
      >
        {this.props.children}
      </WorkOrderContext.Provider>
    )
  }
}

export default WorkOrderContextProvider;